export const DEFAULT_HEADING_SIZES = {
  md: 24,
  sm: 22,
  xs: 20,
};

export const UNSUPPORTED_BROWSERS_HEADING_SIZES = { md: 42, sm: 22, xs: 20 };
